import React from 'react';
import { Lock, Zap, Quote } from 'lucide-react';
import { PaymentLogos } from './PaymentLogos';
const excerpts = [{
  text: "It wasn't poverty that broke us. It was watching how hope faded in the eyes of those we loved most.",
  source: 'Chapter III: The year everything changed'
}, {
  text: 'Venezuela did not die. They buried her alive. And from inside the coffin, her people kept screaming.',
  source: 'Prologue'
}, {
  text: 'Exile is not just a place. It is a wound that bleeds in silence every time someone asks where you are from.',
  source: 'Chapter VII: Those who left'
}];
export function BookExcerpts() {
  return <section className="bg-[#0a0a0a] py-12 sm:py-20 px-6 border-t border-gray-900/60" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        {/* Header */}
        <div className="text-center mb-20 flex flex-col items-center gap-6" data-id="element-21">
          <p className="text-[#d4a85a] uppercase tracking-[0.25em] text-[11px] sm:text-xs font-semibold" data-id="element-22">
            Book Excerpts
          </p>

          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#e8e2d4] font-normal leading-tight" data-id="element-23">
            Words that are not forgotten
          </h2>

          {/* Red-blue-gold divider */}
          <div className="h-px w-32" style={{
          background: 'linear-gradient(to right, #DC2626, #2563eb, #d4a85a)'
        }} data-id="element-24" />
        </div>

        {/* Quotes */}
        <div className="flex flex-col gap-20 sm:gap-24" data-id="element-25">
          {excerpts.map((q, i) => <figure key={i} className="relative pl-8 sm:pl-12" data-id="element-26">
              {/* Decorative quote mark */}
              <Quote className="absolute -top-2 left-0 w-6 h-6 text-[#d4a85a]/40" strokeWidth={1.5} data-id="element-27" />
              {/* Vertical gold accent line */}
              <div className="absolute left-2 top-2 bottom-2 w-px bg-gradient-to-b from-[#d4a85a]/60 via-[#d4a85a]/20 to-transparent" data-id="element-28" />

              <blockquote className="font-serif italic text-[#e8e2d4] text-xl sm:text-2xl lg:text-[26px] leading-[1.55] font-light" data-id="element-29">
                "{q.text}"
              </blockquote>

              <figcaption className="mt-5 text-sm text-gray-500 italic" data-id="element-30">
                — {q.source}
              </figcaption>
            </figure>)}
        </div>

        {/* CTA Block */}
        <div className="mt-12 sm:mt-16 flex flex-col items-center gap-6 text-center" data-id="element-31">
          <a href="https://templeofpages.com/cart/49184174768371:1" className="w-full sm:w-auto bg-[#DC2626] hover:bg-[#b91c1c] text-white font-bold py-5 px-10 sm:px-14 rounded text-base sm:text-lg transition-all duration-300 shadow-[0_0_30px_rgba(220,38,38,0.25)] hover:shadow-[0_0_40px_rgba(220,38,38,0.4)] hover:-translate-y-1 tracking-wide uppercase text-center inline-block no-underline" data-id="element-32">
            Read the Full Book — $19.99
          </a>

          <PaymentLogos data-id="element-33" />

          {/* Trust labels */}
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 text-sm text-gray-500 mt-2" data-id="element-34">
            <div className="flex items-center gap-2" data-id="element-35">
              <Lock className="w-4 h-4" data-id="element-36" />
              <span data-id="element-37">256-bit SSL Encryption · Bank-Grade Security</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-38">
              <Zap className="w-4 h-4" data-id="element-39" />
              <span data-id="element-40">Instant delivery to your email</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}